export const uk = {
    cancel: 'Отмена',
    dayBudgetLimit: 'Ограничение бюджета',
    set: 'Установить',
    walletDayBudgetIsSet:
        'Для общего счета задан режим показов "{mode}" и установлено ограничение дневного бюджета {sum} {currency}. Укажите меньшее значение, чтобы ограничить дневной бюджет кампании.'
};
